import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  standalone: false
})
export class ErrorMessageComponent {
  @Input() error: string;
  @Input() width?: string;
  @Output() retryClicked: EventEmitter<void> = new EventEmitter();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) { }

  onRetry() {
    this.retryClicked.emit();
  }
}
